import React, { memo } from 'react';
import { Info, Lock, Globe, Database, Smartphone, Layers } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
export function ProjectForm() {
  return <section className="py-8" id="contact" data-id="element-166">
      <div className="border-b border-[#d0d7de] mb-6 pb-2" data-id="element-167">
        <h2 className="text-2xl font-semibold text-[#24292f]" data-id="element-168">
          Create a new project
        </h2>
        <p className="text-[#57606a] text-sm mt-1" data-id="element-169">
          A project contains all project files, including the revision history.
          Already have a project repository elsewhere?{' '}
          <a href="#" className="text-[#0969da] hover:underline" data-id="element-170">
            Import a project.
          </a>
        </p>
      </div>

      <form className="max-w-3xl" data-id="element-171">
        <div className="mb-6" data-id="element-172">
          <div className="flex items-end gap-2 mb-2" data-id="element-173">
            <label className="block text-sm font-semibold text-[#24292f]" data-id="element-174">
              Project name <span className="text-red-600" data-id="element-175">*</span>
            </label>
          </div>
          <div className="flex items-center gap-2" data-id="element-176">
            <div className="bg-[#f6f8fa] border border-[#d0d7de] rounded-md px-3 py-1.5 text-sm text-[#57606a] font-mono" data-id="element-177">
              client /
            </div>
            <Input placeholder="my-awesome-project" className="font-mono" data-id="element-178" />
          </div>
          <p className="mt-2 text-xs text-[#57606a]" data-id="element-179">
            Great project names are short and memorable. Need inspiration? How
            about{' '}
            <span className="text-[#1f883d] font-mono cursor-pointer" data-id="element-180">
              super-duper-system
            </span>
            ?
          </p>
        </div>

        <div className="mb-6" data-id="element-181">
          <label className="block text-sm font-semibold text-[#24292f] mb-2" data-id="element-182">
            Description{' '}
            <span className="text-[#57606a] font-normal" data-id="element-183">(optional)</span>
          </label>
          <Input placeholder="Briefly describe what you want to build..." data-id="element-184" />
        </div>

        <div className="mb-6 border-b border-[#d0d7de] pb-6" data-id="element-185">
          <label className="block text-sm font-semibold text-[#24292f] mb-3" data-id="element-186">
            Project Type
          </label>

          <div className="space-y-3" data-id="element-187">
            <label className="flex items-start gap-3 cursor-pointer group" data-id="element-188">
              <input type="radio" name="type" className="mt-1" defaultChecked data-id="element-189" />
              <Globe size={20} className="text-[#57606a] mt-0.5" data-id="element-190" />
              <div data-id="element-191">
                <div className="font-semibold text-[#24292f] text-sm group-hover:text-[#0969da]" data-id="element-192">
                  Web Application
                </div>
                <div className="text-xs text-[#57606a]" data-id="element-193">
                  React, Next.js, Vue, or Angular based web apps
                </div>
              </div>
            </label>

            <label className="flex items-start gap-3 cursor-pointer group" data-id="element-194">
              <input type="radio" name="type" className="mt-1" data-id="element-195" />
              <Smartphone size={20} className="text-[#57606a] mt-0.5" data-id="element-196" />
              <div data-id="element-197">
                <div className="font-semibold text-[#24292f] text-sm group-hover:text-[#0969da]" data-id="element-198">
                  Mobile Application
                </div>
                <div className="text-xs text-[#57606a]" data-id="element-199">
                  iOS, Android, or Cross-platform (React Native/Flutter)
                </div>
              </div>
            </label>

            <label className="flex items-start gap-3 cursor-pointer group" data-id="element-200">
              <input type="radio" name="type" className="mt-1" data-id="element-201" />
              <Database size={20} className="text-[#57606a] mt-0.5" data-id="element-202" />
              <div data-id="element-203">
                <div className="font-semibold text-[#24292f] text-sm group-hover:text-[#0969da]" data-id="element-204">
                  Backend & API
                </div>
                <div className="text-xs text-[#57606a]" data-id="element-205">
                  Scalable server-side logic and database design
                </div>
              </div>
            </label>

            <label className="flex items-start gap-3 cursor-pointer group" data-id="element-206">
              <input type="radio" name="type" className="mt-1" data-id="element-207" />
              <Layers size={20} className="text-[#57606a] mt-0.5" data-id="element-208" />
              <div data-id="element-209">
                <div className="font-semibold text-[#24292f] text-sm group-hover:text-[#0969da]" data-id="element-210">
                  Full Stack Solution
                </div>
                <div className="text-xs text-[#57606a]" data-id="element-211">
                  End-to-end development from design to deployment
                </div>
              </div>
            </label>
          </div>
        </div>

        <div className="mb-6" data-id="element-212">
          <div className="flex items-center gap-2 mb-3" data-id="element-213">
            <Info size={16} className="text-[#57606a]" data-id="element-214" />
            <span className="text-sm font-semibold text-[#24292f]" data-id="element-215">
              Initialize this project with:
            </span>
          </div>

          <div className="space-y-3 pl-6" data-id="element-216">
            <label className="flex items-center gap-2 cursor-pointer" data-id="element-217">
              <input type="checkbox" className="rounded border-gray-300" data-id="element-218" />
              <span className="text-sm text-[#24292f] font-semibold" data-id="element-219">
                Add a README file
              </span>
              <span className="text-xs text-[#57606a]" data-id="element-220">
                - This is where you can write a long description for your
                project.
              </span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer" data-id="element-221">
              <input type="checkbox" className="rounded border-gray-300" data-id="element-222" />
              <span className="text-sm text-[#24292f] font-semibold" data-id="element-223">
                Add .gitignore
              </span>
              <span className="text-xs text-[#57606a]" data-id="element-224">
                - Choose which files not to track from a list of templates.
              </span>
            </label>
          </div>
        </div>

        <div className="pt-4 border-t border-[#d0d7de] flex items-center gap-4" data-id="element-225">
          <Button variant="primary" className="font-semibold" data-id="element-226">
            Create project request
          </Button>
          <span className="text-xs text-[#57606a]" data-id="element-227">
            By creating a project request, you agree to the{' '}
            <a href="#" className="text-[#0969da] hover:underline" data-id="element-228">
              Terms of Service
            </a>
            .
          </span>
        </div>
      </form>
    </section>;
}